export default __webpack_public_path__ + "static/media/Ford_BuildingTogether_Blue_Screen_RGB_Vt_v2.a09322e4.png";